import { Button, Stack, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import StyledModal from '../../../components/styles/StyledModal';

type Props = {
  open: boolean;
  onClose: () => void;
  onCreate: (name: string) => Promise<void>;
};

export default function InlineCreateCategoryModal({ open, onClose, onCreate }: Props) {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setName('');
  }, [open]);

  const canSave = name.trim().length > 0;

  const handleCreate = async () => {
    if (!canSave) return;
    setSaving(true);
    try {
      await onCreate(name);
    } finally {
      setSaving(false);
    }
  };

  return (
    <StyledModal
      open={open}
      onClose={onClose}
      title="New document category"
      actions={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => void handleCreate()}
            disabled={!canSave || saving}
          >
            Create
          </Button>
        </>
      }
    >
      <Stack spacing={2} sx={{ px: 3, pb: 1, pt: 1, minWidth: 320 }}>
        <TextField
          label="Name"
          size="small"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
        />
      </Stack>
    </StyledModal>
  );
}
